export default "__VITE_ASSET__DCRTUanm__"